export interface Formula {
  titleKey: string; // Clé de traduction du titre
  subtitleKey: string; // Clé de traduction du sous-titre
  featuresKey: string; // Clé de traduction pour les fonctionnalités incluses
  priceKey: string; // Clé de traduction du devis
  addonsKey?: string; // Clé de traduction pour les options supplémentaires
}

// Nouvelle structure: une seule et unique formule
export const formula: Formula = {
  titleKey: "single.title",
  subtitleKey: "single.subtitle",
  featuresKey: "single.features",
  addonsKey: "single.addons",
  priceKey: "single.price",
};
